// extracted by mini-css-extract-plugin
module.exports = {"root":"AgPkq","bg":"_1htNC"};